export type SetFaviconOptions = {
    /** Добавляет cache-bust параметр, чтобы браузер не брал старую иконку из кеша */
    bustCache?: boolean;
};

function withCacheBust(url: string) {
    const sep = url.includes('?') ? '&' : '?';
    return `${url}${sep}v=${Date.now()}`;
}

/**
 * Динамически устанавливает favicon.
 * Важно: Chrome/Edge иногда кешируют favicon, поэтому по умолчанию удобно включать bustCache.
 */
export function setFavicon(url: string, options: SetFaviconOptions = {}) {
    if (!url) return;

    const href = options.bustCache ? withCacheBust(url) : url;

    // Удаляем старые icon-теги, чтобы браузер не "выбирал" другой из нескольких.
    document.querySelectorAll('link[rel*="icon"]').forEach((el) => el.remove());

    const makeLink = (rel: string) => {
        const link = document.createElement('link');
        link.rel = rel;
        link.href = href;
        document.head.appendChild(link);
    };

    makeLink('shortcut icon');
}